export default "/images/lider-simbolo.svg?7bccf89ba0798c9914584eb7f9341045";